import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useGetMainComponentById } from 'src/api/main-component'
import { MoveReportEquipmentPicker } from 'src/components/overallReport/MoveReportEquipmentPicker'
import { IMoveReportTarget } from 'src/generated-types/form-schema'
import { formatItemIdentification } from 'src/utils/function'
import { getTranslatedText } from 'src/utils/translations'

interface UpdateDeviationEquipmentSectionProps {
  customerId: EntityId
  localityId?: EntityId
  mainComponentId: number
  selected?: IMoveReportTarget
  onSelect: (target: IMoveReportTarget) => void
}

export const UpdateDeviationEquipmentSection: React.FC<UpdateDeviationEquipmentSectionProps> = ({
  customerId,
  localityId,
  mainComponentId,
  selected,
  onSelect,
}) => {
  const { t } = useTranslation(['deviation'])
  const { data: current } = useGetMainComponentById(customerId, mainComponentId)

  return (
    <Box
      width={'100%'}
      display="flex"
      flexDirection="column"
      gap={1.5}
      mb={2}
      px={1}
      sx={{ ml: '10px', boxSizing: 'border-box' }}
    >
      <Typography variant="body2">
        {t('current-equipment', { ns: 'deviation' })}:{' '}
        <Typography component="span" variant="body2" fontWeight={600}>
          {current
            ? formatItemIdentification({
                itemType: getTranslatedText(current.type?.name),
                serialNumber: current.serialNumber,
              })
            : ''}
        </Typography>
      </Typography>
      {selected && (
        <Typography variant="body2" color="primary">
          {t('moves-to', { ns: 'deviation' })}:{' '}
          <Typography component="span" variant="body2" fontWeight={600}>
            {selected.secondaryLabel ? `${selected.label} (${selected.secondaryLabel})` : selected.label}
          </Typography>
        </Typography>
      )}
      <MoveReportEquipmentPicker
        customerId={customerId}
        excludedId={mainComponentId}
        localityId={localityId}
        selected={selected}
        onSelect={onSelect}
      />
    </Box>
  )
}
